export class LeagueQueryState {
    static UPCOMING: string = 'upcoming';
    static IN_PROGRESS: string = 'inProgress';
    static FINISHED: string = 'finished';
    static SETUP: string = 'setup';
}

export interface LeagueQueryLimit {
    total?: number;
    inProgress?: number;
    finished?: number;
    upcoming?: number;
    offset?: number;
}

export interface ILeagueQuery {
    id?: number;
    leagueIds?: number[],
    contestantId?: number;
    types?: string[];
    states?: string[];
    skillLevels?: string[];
    portals?: string[];
    tags?: string[];
    path?: string;
    limit?: LeagueQueryLimit;
    teamSizes?: number[];
    fields?: string[];
    gameIds?: number[];
    excludeTags?: string[];
    from?: string;
    to?: string;
    includeHidden?: boolean;
}

export class LeagueQuery implements ILeagueQuery {
    public id: number;
    public leagueIds: number[];
    public contestantId: number;
    public types: string[];
    public states: string[];
    public skillLevels: string[];
    public portals: string[];
    public tags: string[];
    public path: string;
    public limit: LeagueQueryLimit;
    public teamSizes: number[];
    public fields: string[];
    public gameIds: number[];
    public excludeTags: string[];
    public from: string;
    public to: string;
    public includeHidden: boolean;

    constructor(fields?: ILeagueQuery) {
        if (typeof fields === 'object') {
            if (fields.hasOwnProperty('id'))
                this.id = fields.id;
            if (fields.hasOwnProperty('leagueIds'))
                this.leagueIds = fields.leagueIds;
            if (fields.hasOwnProperty('contestantId'))
                this.contestantId = fields.contestantId;
            if (fields.hasOwnProperty('types'))
                this.types = fields.types;
            if (fields.hasOwnProperty('states'))
                this.states = fields.states;
            if (fields.hasOwnProperty('skillLevels'))
                this.skillLevels = fields.skillLevels;
            if (fields.hasOwnProperty('portals'))
                this.portals = fields.portals;
            if (fields.hasOwnProperty('tags'))
                this.tags = fields.tags;
            if (fields.hasOwnProperty('path'))
                this.path = fields.path;
            if (fields.hasOwnProperty('limit'))
                this.limit = fields.limit;
            if (fields.hasOwnProperty('teamSizes'))
                this.teamSizes = fields.teamSizes;
            if (fields.hasOwnProperty('fields'))
                this.fields = fields.fields;
            if (fields.hasOwnProperty('gameIds'))
                this.gameIds = fields.gameIds;
            if (fields.hasOwnProperty('excludeTags'))
                this.excludeTags = fields.excludeTags;
            if (fields.hasOwnProperty('includeHidden'))
                this.includeHidden = fields.includeHidden;
        }
    }

    public setTypes(types: string[]): LeagueQuery {
        this.types = types;

        return this;
    }

    public setStates(states: string[]): LeagueQuery {
        this.states = states;

        return this;
    }

    public setSkillLevels(skillLevels: string[]): LeagueQuery {
        this.skillLevels = skillLevels;

        return this;
    }

    public setPortals(portals: string[]): LeagueQuery {
        this.portals = portals;

        return this;
    }

    public setTags(tags: string[]): LeagueQuery {
        this.tags = tags;

        return this;
    }

    public setPath(path: string): LeagueQuery {
        this.path = path;

        return this;
    }

    public setLimit(limit: LeagueQueryLimit): LeagueQuery {
        this.limit = limit;

        return this;
    }

    public setTeamSizes(teamSizes: number[]): LeagueQuery {
        this.teamSizes = teamSizes;

        return this;
    }

    public setId(id: number): LeagueQuery {
        this.id = id;

        return this;
    }

    public setContestantId(contestantId: number): LeagueQuery {
        this.contestantId = contestantId;

        return this;
    }

    public setFields(fields: string[]): LeagueQuery {
        this.fields = fields;

        return this;
    }

    public setGameIds(gameIds: number[]): LeagueQuery {
        this.gameIds = gameIds;

        return this;
    }

    public setExcludeTags(excludeTags: string[]): LeagueQuery {
        this.excludeTags = excludeTags;

        return this;
    }

    public setLeagueIds(leagueIds: number[]): LeagueQuery {
        this.leagueIds = leagueIds;

        return this;
    }

    public setFrom(dateFrom: string): LeagueQuery {
        this.from = dateFrom;

        return this;
    }

    public setTo(dateTo: string): LeagueQuery {
        this.to = dateTo;

        return this;
    }

    public setIncludeHidden(includeHidden : boolean): LeagueQuery {
        this.includeHidden = includeHidden;

        return this;
    }
}